/**
 * Collection node (service node) operations for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class ColNodeManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async pageColNodes(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/col_node/extend/page', { params });
  }

  async getColNode(uuid: string): Promise<Record<string, any>> {
    return this.session.get(`/api/col_node/get/${uuid}`);
  }

  async createColNode(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/col_node/extend/create', { data });
  }

  async updateColNode(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/col_node/update', { data });
  }

  async deleteColNode(uuid: string): Promise<Record<string, any>> {
    return this.session.post(`/api/col_node/delete/${uuid}`);
  }

  async batchDeleteColNodes(uuids: string[]): Promise<Record<string, any>> {
    return this.session.post('/api/col_node/batchDelete', { data: uuids });
  }

  async getColNodeTree(projectUuid: string): Promise<Record<string, any>> {
    return this.session.get('/api/col_node/extend/queryTree', { params: { projectUuid } });
  }

  async invocateService(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/col_node/extend/invocateService', { data });
  }

  async invocateServiceBlob(data: Record<string, any>): Promise<Blob> {
    return this.session.request('POST', '/api/cdp/col_node/extend/invocateService', {
      data,
      responseType: 'blob',
    });
  }
}
